import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wanjie",
  "use": "icon-wanjie-usage",
  "viewBox": "0 0 49.546 49.546",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 49.546 49.546\" id=\"icon-wanjie\">\r\n  <path id=\"icon-wanjie_wanjie\" d=\"M85.047,43.073a35.429,35.429,0,0,0,.718,4.821s-4.876,2.172-10.075,8.213V73.961H36.219V24.415h28.06L75.69,35.068v9.115a31.949,31.949,0,0,1,9.446-8.075S84.867,40.573,85.047,43.073Zm-20.768-15v7H71.61Zm8.715,31.361a53.235,53.235,0,0,0-4.93,7.125s-1.089-1.462-2.66-3.215h-23.8V62.076H64.229a29.425,29.425,0,0,0-2.9-2.665q-.2-.155-.395-.306H41.606V57.843H59.2a43.111,43.111,0,0,0-4.431-2.717l1.044-.624h-14.2V53.239H57.919l5.215-3.119H41.507V48.857H70.085v1.262H63.709l1.656,3.119H68.54V54.5h-2.5l1.774,3.342h.12a45.042,45.042,0,0,1,5.064-10V37.494H61.688V27.136H38.916v44.1H72.994ZM56.9,32.271h-15.4V30.86H56.9Zm0,4.456h-15.4V35.316H56.9Zm13.18,4.258H41.507V39.722H70.084Zm0,4.679H41.507V44.4H70.084ZM66.048,67.126H41.606V65.863H66.048Z\" transform=\"translate(-36.219 -24.415)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/wanjie.svg
// module id = rOuF
// module chunks = 5